import { lazy, Suspense, useEffect } from 'react';
import { Route, Routes, useLocation } from 'react-router-dom';
import { MotionConfig } from 'motion/react';
import Nav from '~/components/Nav';
import Footer from '~/components/Footer';
import Home from '~/routes/Home';
import Pricing from '~/routes/Pricing';
import Docs from '~/routes/Docs';
import ApiReference from '~/routes/ApiReference';
import Auth from '~/routes/Auth';
import Payment from '~/routes/Payment';
import NotFound from '~/routes/NotFound';

// Lazy so recharts (only used here) stays out of the main bundle.
const Account = lazy(() => import('~/routes/Account'));

export default function App() {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return (
    <MotionConfig reducedMotion="user">
      <Nav />
      <main>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/pricing" element={<Pricing />} />
          <Route path="/docs" element={<Docs />} />
          <Route path="/docs/api" element={<ApiReference />} />
          <Route path="/login" element={<Auth />} />
          <Route path="/register" element={<Auth />} />
          <Route path="/account" element={<Suspense fallback={null}><Account /></Suspense>} />
          <Route path="/payment" element={<Payment />} />
          <Route path="*" element={<NotFound />} />
        </Routes>
      </main>
      <Footer />
    </MotionConfig>
  );
}
